<template>
  <div>
    <div class="vx-row items-center">
      <vx-card class="overflow-auto">
        <vs-tabs v-model="tabIndex" class="settings-tab">
          <vs-tab vs-label="HTML" label="Personal Information" icon="speakol-contact-us" icon-pack="speakol"
                  v-on:click.prevent="goTo('personal')" v-if="$can('personal_settings')">
          </vs-tab>
          <vs-tab vs-label="HTML" label="Account Details" icon="speakol-data-protection" icon-pack="speakol"
                  v-on:click.prevent="goTo('account')" v-if="$can('view_personal_account_settings')">
          </vs-tab>
          <vs-tab vs-label="HTML" label="Users" icon="speakol-user-account" icon-pack="speakol"
                  v-on:click.prevent="goTo('users')" v-if="$can('view_sub_users')">
          </vs-tab>
          <vs-tab vs-label="HTML" label="Subaccounts" icon="speakol-network" icon-pack="speakol"
                  v-on:click.prevent="goTo('subaccounts')" v-if="$hasFeature('sub-accounts') && $can('view_sub_accounts')">
          </vs-tab>
        </vs-tabs>
      </vx-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
/* eslint-disable multiline-ternary */
export default {
  data () {
    return {
      tabIndex: '0'
    }
  },
  beforeMount () {
    this.setupTabsBar()
  },
  methods: {
    setupTabsBar () {
      const routeName = this.$route.name

      if (routeName === 'settings') {
        return this.$router.push('/settings/personal')
      }

      const accountIndex = this.$can('personal_settings') ? 1 : 0

      const usersIndex = this.$can('personal_settings', 'view_personal_account_settings') ? 2 :
        this.$can('personal_settings') ||
        this.$can('view_personal_account_settings') ? 1 : 0

      const subAccountsIndex = this.$can('personal_settings', 'view_personal_account_settings', 'view_sub_users') ? 3 :
        this.$can('view_personal_account_settings', 'view_sub_users') ||
        this.$can('personal_settings', 'view_sub_users') ||
        this.$can('personal_settings', 'view_personal_account_settings') ? 2 :
          this.$can('personal_settings') ||
          this.$can('view_personal_account_settings') ||
          this.$can('view_sub_users')  ? 1 : 0

      const tabUrlMap = {
        'personal': 0,
        'account': accountIndex,
        'users': usersIndex,
        'user-details': usersIndex,
        'subaccounts': subAccountsIndex,
        'subaccount-details': subAccountsIndex
      }

      this.tabIndex = tabUrlMap[routeName]
    },
    goTo (param) {
      if (this.$route.name === param) return

      this.$router.push(`/settings/${param}`)
    }
  }
}
</script>

<style lang="scss">
  .edit-section-btn {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
  }

  .settings-tab {
    min-width: 700px;

    .vs-tabs--li {
      margin-left: 15px;
      margin-right: 15px;
    }
  }
</style>
